// extracted by mini-css-extract-plugin
export var colorSquare = "_ts-0";
export var danger = "_ts-5";
export var lightPink = "_ts-8";
export var neutralBlue = "_ts-7";
export var neutralYellow = "_ts-6";
export var normal = "_ts-1";
export var primary = "_ts-2";
export var primaryLight = "_ts-3";
export var solidBlack = "_ts-g";
export var solidGreen = "_ts-b";
export var solidLightBlue = "_ts-d";
export var solidNavy = "_ts-c";
export var solidOrange = "_ts-f";
export var solidPink = "_ts-e";
export var solidRed = "_ts-9";
export var solidYellow = "_ts-a";
export var success = "_ts-4";